<template>
  <div class="stepOneMain">
    <div class="scroll_wrap">
      <vue-scroll ref="scroll">
        <el-form
          ref="plainInfo"
          :model="plainInfo"
          :rules="formRules"
          label-width="180px"
          class="black_form"
        >
<!--          <el-form-item label="主教练"-->
<!--          ><div style="font-size: 16px">-->
<!--            {{ chiefCoachName }}-->
<!--          </div>-->
<!--          </el-form-item>-->
          <el-form-item label="比赛性质" prop="matchType">
            <el-select
                v-model="plainInfo.matchType"
                placeholder="请选择比赛性质"
                class="w445"
            >
              <el-option
                  v-for="(item, index) in matchTypeList"
                  :key="index"
                  :label="item"
                  :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="比赛名称" prop="matchName">
            <el-input
                v-model="plainInfo.matchName"
                class="w445"
                placeholder="请输入比赛名称"
                maxlength="100"
                show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="比赛对手" prop="vs">
            <el-input
                v-model="plainInfo.vs"
                class="w445"
                placeholder="请输入比赛对手"
                maxlength="100"
                show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="比赛地点" prop="matchPlace">
            <el-input
                v-model="plainInfo.matchPlace"
                class="w445"
                placeholder="请输入比赛地点"
                maxlength="100"
                show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="开场时间" prop="matchTime">
            <el-date-picker
              v-model="plainInfo.matchTime"
              class="w445"
              type="datetime"
              placeholder="请选择开场时间"
              value-format="timestamp"
              :editable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="比赛时长" prop="matchTotalTime">
            <el-input
                v-model="plainInfo.matchTotalTime"
                style="width: 100px; margin-right: 10px"
            ></el-input
            >分钟
          </el-form-item>
          <el-form-item label="天气" prop="weather">
            <el-select
                v-model="plainInfo.weather"
                class="w445"
                placeholder="请选择天气"
            >
              <el-option
                  v-for="(item, index) in weatherList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主要阵型" prop="teamFormation">
            <el-select
                v-model="plainInfo.teamFormation"
                class="w445"
                placeholder="请选择主要阵型"
            >
              <el-option
                  v-for="(item, index) in teamFormationList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="比赛结果" prop="matchResult">-->
<!--            <el-select-->
<!--                v-model="plainInfo.matchResult"-->
<!--                class="w445"-->
<!--                placeholder="请选择主要阵型"-->
<!--            >-->
<!--              <el-option-->
<!--                  v-for="(item, index) in matchResultList"-->
<!--                  :key="index"-->
<!--                  :label="item.name"-->
<!--                  :value="item.value"-->
<!--              ></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <div style="display: flex">
            <el-form-item label="比赛结果" prop="matchResult">
              <el-select
                  v-model="plainInfo.matchResult"
                  class="w150"
                  placeholder="请选择比赛结果"
              >
                <el-option
                    v-for="(item, index) in matchResultList"
                    :key="index"
                    :label="item"
                    :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="10px" prop="goalScore">
              进球<el-input v-model="plainInfo.goalScore" style="width: 90px; margin-right: 10px;margin-left: 10px;"></el-input>：
            </el-form-item>
            <el-form-item label-width="10px" prop="goalConceded">
              失球<el-input v-model="plainInfo.goalConceded" style="width: 90px; margin-right: 10px;margin-left: 10px;"></el-input>
            </el-form-item>
          </div>

          <!-- ================================= -->
<!--          <el-form-item label="比赛总体描述">-->
<!--            <quill-editor-->
<!--                v-model="plainInfo.overallEvalComment"-->
<!--                class="simple_editor"-->
<!--                :options="editorOption"-->
<!--            ></quill-editor>-->
<!--          </el-form-item>-->
        </el-form>
      </vue-scroll>
    </div>
    <div class="next_btn_wrap">
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        @click="saveData('temporarily')"
        >编写完成并保存</el-button
      >
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        :loading="saveBtn"
        @click="saveData('next')"
        >下一步</el-button
      >
      <el-button type="danger" @click="showTip = true">取消</el-button>
    </div>
    <yioks-tip
      :showTip="showTip"
      :tipMsg="$t('waivedSubmission')"
      @callback="goBack"
    ></yioks-tip>
    <yioks-tip
      :showTip="temporarily"
      :tipMsg="tips"
      @callback="saveTemporarily"
    ></yioks-tip>
    <yioks-tip
      :showTip="confirmSubmit"
      :tipMsg="confirmTips"
      @callback="confirmSave"
    ></yioks-tip>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; // 富文本编辑器，下面的样式必须引入
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import common from "@/api/common";
import match from "@/api/match";
import storage from "@/utils/storage";
export default {
  components: {
    quillEditor,
    Pagination: () => import("@/components/Pagination"),
    "yioks-sspviewer": () => import("@/components/sspViewer/sppCanvas"),
    FlashTips: () => import("@/components/FlashTips"),
  },
  data() {
    return {
      // 表单信息
      tips: "确定暂时保存并返回吗?",
      confirmSubmit: false, // 确认提交
      confirmTips: "确定保存并进入下一步吗?",
      plainInfo: {
        matchType: "", // 比赛性质
        matchName: "", // 比赛名称
        vs: "", // 比赛对手
        matchPlace: "", // 比赛地点
        matchTime: "", // 开场时间
        matchTotalTime: 0, // 比赛总时长
        weather: "", // 天气
        teamFormation: "", // 主要阵型
        goalScore: 0, // 进球
        goalConceded: 0, // 失球
        matchResult: "", // 比赛结果
        // overallEvalComment: "", // 训练总体描述
      },
      // 表单验证规则
      formRules: {
        matchType: [{ required: true, message: "请选择比赛性质", trigger: "change" }],
        matchName: [{ required: true, message: "请输入比赛名称", trigger: "blur" }],
        vs: [{ required: true, message: "请输入比赛对手", trigger: "blur" }],
        matchPlace: [{ required: true, message: "请输入比赛地点", trigger: "blur" }],
        matchTime: [{ required: true, message: "请选择开场时间", trigger: "change" },],
        matchTotalTime: [{ required: true,
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
              callback(new Error('请输入比赛时长'))
            } else {
              if (/^[0-9]{1,3}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入0-999内的比赛时长'))
              }
            }
          },
          trigger: 'blur' }],
        weather: [{ required: true, message: "请选择比赛天气", trigger: "change" },],
        teamFormation: [{ required: true, message: "请选择主要阵型", trigger: "change" },],
        matchResult: [{ required: true, message: "请选择比赛结果", trigger: "change" },],
        goalScore: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
              callback(new Error('请输入进球数'))
            } else {
              if (/^[0-9]{1,3}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入0-999内的进球数'))
              }
            }
          },
          trigger: 'blur'
        }],
        goalConceded: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
              callback(new Error('请输入失球数'))
            } else {
              if (/^[0-9]{1,3}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入0-999内的失球数'))
              }
            }
          },
          trigger: 'blur'
        }],
      },
      // 天气
      weatherList: [
        {name: "晴", value: "晴",},
        {name: "多云", value: "多云",},
        {name: "阴", value: "阴",},
        {name: "阵雨", value: "阵雨",},
        {name: "小雨", value: "小雨",},
        {name: "中雨", value: "中雨",},
        {name: "大雨", value: "大雨",},
        {name: "雨夹雪", value: "雨夹雪",},
        {name: "小雪", value: "小雪",},
        {name: "中雪", value: "中雪",},
        {name: "大雪", value: "大雪",},
      ],
      // 比赛性质
      matchTypeList: ["友谊赛", "锦标赛", "联赛", "国际比赛"],
      // 比赛结果
      matchResultList: ["胜", "平", "负"],
      // 主要阵型
      teamFormationList: [
        { name: "4-4-2", value: "4-4-2" },
        { name: "4-4-2(D)", value: "4-4-2(D)" },
        { name: "4-5-1", value: "4-5-1" },
        { name: "4-3-3", value: "4-3-3" },
        { name: "4-2-3-1", value: "4-2-3-1" },
        { name: "4-1-4-1", value: "4-1-4-1" },
        { name: "4-1-3-2", value: "4-1-3-2" },
        { name: "4-4-1-1", value: "4-4-1-1" },
        { name: "3-1-5-1", value: "3-1-5-1" },
        { name: "3-2-3-1-1", value: "3-2-3-1-1" },
        { name: "3-1-4-2", value: "3-1-4-2" },
        { name: "5-3-2", value: "5-3-2" },
        { name: "5-3-1-1", value: "5-3-1-1" },
        { name: "1-4-4-1", value: "1-4-4-1" },
        { name: "3-2-2-3", value: "3-2-2-3" },
        { name: "3-5-1-1", value: "3-5-1-1" },
        { name: "3-5-2", value: "3-5-2" },
        { name: "3-4-3", value: "3-4-3" },
        { name: "5-4-1", value: "5-4-1" },
        { name: "3-3-1", value: "3-3-1" },
        { name: "3-1-3", value: "3-1-3" },
        { name: "3-2-2", value: "3-2-2" },
        { name: "2-3-2", value: "2-3-2" },
        { name: "4-2-1", value: "4-2-1" },
        { name: "4-1-2", value: "4-1-2" },
        { name: "1-2-1", value: "1-2-1" },
        { name: "3-1", value: "3-1" },
        { name: "1-3", value: "1-3" },
        { name: "2-2", value: "2-2" },
      ],
      // vue-edit 设置，只需要三个
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线
          ],
        },
        placeholder: this.$t("defaultPlaceholder"),
      },
      userRole: storage.get("userInfo").userRole, // 登录角色
      idx: 0, // 第几个环节
      showTip: false, // 取消提示
      squadUuid: this.$route.query.squadUuid,
      squadInfo: {}, // 球队的详情
      temporarily: false, // 暂时保存提示
      data: "", // 需要保存的数据
      matchReportUuid: this.$route.query.uuid,
      saveBtn: false, // 下一步按钮 loading
    };
  },

  computed: {
  },

  watch: {
  },
  created() {
    this.getCommon();
    if (this.matchReportUuid) this.getMatchReportInfo();
  },
  methods: {
    // 教案列表 - 获取球队
    getCommon() {
      if (this.squadUuid) {
        common.getSquadInfo(this.squadUuid).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.squadInfo = res.squad;
          }
        });
      }
    },
    // 当存在 matchReportUuid 存在时，代表编辑，请求回显数据
    getMatchReportInfo() {
      match.matchReportInfo(this.matchReportUuid).then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          this.$router.push("/home/index");
        } else {
          this.squadUuid = res.squadUuid; // 球队uuid
          this.plainInfo.matchType = res.matchType; //比赛性质
          this.plainInfo.matchName = res.matchName;//比赛名称
          this.plainInfo.vs = res.vs;//比赛对手
          this.plainInfo.matchPlace = res.matchPlace;//比赛地点
          this.plainInfo.matchTime = res.matchTime;//比赛开始时间
          this.plainInfo.matchTotalTime = res.matchTotalTime;//比赛总时长
          this.plainInfo.weather = res.weather;//比赛天气
          this.plainInfo.teamFormation = res.teamFormation;//主要阵型
          this.plainInfo.goalScore = res.goalScore;//进球数
          this.plainInfo.goalConceded = res.goalConceded;//失球数
          this.plainInfo.matchResult = res.matchResult;//胜负
          // this.plainInfo.overallEvalComment = res.overallEvalComment;//比赛总体描述
          this.plainInfo.organShortName = this.squadInfo.organShortName;
          this.plainInfo.organUuid = this.squadInfo.organUuid;
          this.plainInfo.youthUuid = this.squadInfo.youthUuid;
          this.plainInfo.youthShortName = this.squadInfo.youthShortName;
        }
      });
    },
    // 球队信息
    // 返回
    goBack(isShow) {
      if (isShow) {
        this.$router.go(-1);
      }
      this.showTip = false;
    },
    // 下一步，保存数据
    saveData(val) {
      this.$refs["plainInfo"].validate((valid) => {
        if (valid) {

          this.data = {
            organShortName: this.squadInfo.organShortName,// 会员协会简称
            organUuid: this.squadInfo.organUuid,// 会员协会uuid
            youthUuid: this.squadInfo.youthUuid,// 青训机构uuid
            youthShortName: this.squadInfo.youthShortName,// 青训机构简称
            squadUuid: this.squadUuid,// 球队uuid
            matchType:this.plainInfo.matchType,//比赛性质
            matchName:this.plainInfo.matchName,//比赛名称
            vs:this.plainInfo.vs,//比赛对手
            matchPlace:this.plainInfo.matchPlace,//比赛地点
            matchTime:this.plainInfo.matchTime,//比赛开始时间
            matchTotalTime:this.plainInfo.matchTotalTime,//比赛总时长
            weather:this.plainInfo.weather,//比赛天气
            teamFormation:this.plainInfo.teamFormation,//主要阵型
            goalScore:this.plainInfo.goalScore,//进球数
            goalConceded:this.plainInfo.goalConceded,//失球数
            matchResult:this.plainInfo.matchResult,//比赛胜负
            // overallEvalComment:this.plainInfo.overallEvalComment,//比赛总体描述
            uuid: this.matchReportUuid,
          }
          if (val === "temporarily") {
            this.temporarily = true;
          } else {
            this.saveBtn = true;
            this.confirmSubmit = true;
          }
        }
      });
    },
    // 暂时保存并返回列表
    saveTemporarily(isSure) {
      if (isSure) {
        match.FirstMatchReport(this.data).then((res) => {
          this.$router.go(-1);
        });
      } else {
        this.temporarily = false;
      }
    },
    // 确定保存并返回列表
    confirmSave(isSure) {
      if (isSure) {
        match.FirstMatchReport(this.data).then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              this.saveBtn = false;
              this.confirmSubmit = false;
            } else {
              this.saveBtn = false;
              this.confirmSubmit = false;
              this.$emit("changeNav", {
                jump: 1,
                uuid: res.uuid,
                matchReportStatus: res.matchReportStatus,
                squadUuid: this.squadUuid,
              });
            }
          })
          .catch((err) => {
            this.confirmSubmit = false;
            this.saveBtn = false;
          });
      } else {
        this.confirmSubmit = false;
        this.saveBtn = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.stepOneMain
  display flex
  justify-content space-between
  flex-direction column
  height 590px
  .scroll_wrap
    height 540px
    padding 20px 10px
    background-color $black_color
    overflow hidden
    .w445
      width: 445px;
    .w150
      width: 150px;
    .link_item
      margin-right 20px
      .line
        margin-right 0
      .link_title
        display flex
        align-items center
        font-size 20px
        margin-bottom 20px
        margin-left 20px
        img
          width 28px
          height 28px
          margin-right 20px
      .info_wrap
        display flex
        .img_wrap
          position relative
          margin-left 20px
          height 100px
          img
            width 170px
            height 100px
          .detail
            background #FFF
            width 80px
            height 30px
            border-radius 5px
            color #999
            font-size 16px
            line-height 30px
            text-align center
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            cursor pointer
      .slider
        width 445px
        position relative
        .time
          position absolute
          font-size 16px
          right -50px
          top -5px
  .tutorial_wrap
    height 590px
    display flex
    flex-direction column
    .search_wrap
      display flex
      border-bottom 1px solid #DDD
      padding 20px 0
      margin 0 20px 10px
    .tutorial
      flex 1
      overflow hidden
      color #999
      font-size 16px
      .item
        padding 10px 0
        border-bottom 1px solid #CCC
        margin 0 20px
        .title
          padding 10px 0 25px 0
          font-size 20px
          font-weight bold
          color #000
        .info_content
          display flex
          img
            width 207px
            height 121px
            margin-right 25px
          .info
            display flex
            flex-direction column
            justify-content center
            flex 1
            p
              margin-bottom 10px
          .btn_wrap
            margin-right 40px
            .btn
              background $green_color2
              color #FFF
              height 40px
              text-align center
              line-height 40px
              margin 20px auto 0
              cursor pointer
  .detail_wrap
    padding 20px
    padding-right 0
    height 560px
    overflow hidden
    .title
      font-size 22px
      padding-bottom 20px
      margin-right 20px
      border-bottom 1px solid #DDD
    .detail
      display flex
      margin-right 20px
      .tutorial_wrap
        width 340px
        height 203px
        position relative
        .tutorial, .tutorial_img
          position absolute
          left 0
          top 0
          z-index 2
        .tutorial_img
          z-index 1
          width 336px
          height 198px
          top 4px
      .info
        font-size 18px
        padding 20px 0 0 20px
        p
          margin-bottom 20px
    .description
      font-size 18px
      padding 25px 0
  .next_btn_wrap
    width 100%
    display flex
    justify-content center
.plan-upload
  /deep/.el-upload__tip
    color #fff !important
.hide-upload
  /deep/.el-upload--picture-card
    display none !important
    // visibility hidden !important
    transition all 0.5s
.el-radio
  color white
</style>
<!--<style lang="stylus" scoped>-->
<!--.el-slider__marks .el-slider__marks-text-->
<!--  color white !important-->
<!--</style>-->
